import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/** `/$tenant/agents` — entrée « Agents » hors projet : redirige vers le dernier projet ouvert (lot L08). */
export const Route = createFileRoute('/$tenant/agents')({ component: AgentsRedirect });

function AgentsRedirect() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="agents" crumbs={[{ label: t('nav.items.agents') }]}>
      <ProjectResolver tenantId={tenant} section="agents" />
    </ConsoleShell>
  );
}
